import React from 'react'
import {connect} from 'react-redux'
import {Link, withRouter} from 'react-router-dom'
import {Menu, Layout} from 'antd'
import store from 'store'
import {Scrollbars} from 'react-custom-scrollbars'

import loadData from 'config/menu'
import modulesData from 'config/modules'

import _ from 'lodash'
import styles from './style.module.scss'
import {compose} from "redux";

const {Sider} = Layout;
const {SubMenu} = Menu;

const menuData = [...loadData, ...modulesData.filter(e => !!e.menu)];

const mapStateToProps = ({settings, user}) => ({
  isMenuCollapsed: settings.isMenuCollapsed,
  isMobileView: settings.isMobileView,
  isSettingsOpen: settings.isSettingsOpen,
  isLightTheme: settings.isLightTheme,
  isMobileMenuOpen: settings.isMobileMenuOpen,
  user,
});

class MenuLeft extends React.Component {
  state = {
    selectedKeys: store.get('app.menu.selectedKeys') || [],
    openedKeys: store.get('app.menu.openedKeys') || [],
  };

  componentDidMount() {
    this.setSelectedKeys(this.props)
  }

  componentWillReceiveProps(newProps) {
    if (newProps.isMenuCollapsed && !newProps.isMobileView) {
      this.setState({
        openedKeys: [],
      })
    }
    this.setSelectedKeys(newProps)
  }

  setSelectedKeys = props => {
    const locationSegment = props.location.pathname.split('/');
    const flattenItems = (items, key) =>
      items.reduce((flattenedItems, item) => {
        flattenedItems.push(item);
        if (Array.isArray(item[key])) {
          return flattenedItems.concat(flattenItems(item[key], key))
        }
        return flattenedItems
      }, []);

    if(menuData.length < 1) {
      return;
    }

    const flattenMenuItems = flattenItems(menuData, 'children');
    flattenMenuItems.map(m => {
      if(!m.key) {
        m.key = m.module;
      }
      return m;
    });

    const selectedItem = _.find(flattenMenuItems, [
      'key',
      locationSegment[1],
    ]);

    this.setState({
      selectedKeys: selectedItem ? [selectedItem.key] : [],
    })
  };

  onCollapse = (value, type) => {
    const {dispatch, isMenuCollapsed} = this.props;
    if (type === 'responsive' && isMenuCollapsed) {
      return
    }

    dispatch({
      type: 'settings/CHANGE_SETTING',
      payload: {
        setting: 'isMenuCollapsed',
        value: !isMenuCollapsed,
      },
    });

    this.setState({
      openedKeys: [],
    })
  };

  onOpenChange = openedKeys => {
    store.set('app.menu.openedKeys', openedKeys);
    this.setState({
      openedKeys,
    })
  };

  handleClick = e => {
    store.set('app.menu.selectedKeys', [e.key]);
    this.setState({
      selectedKeys: [e.key],
      // openKeys: e.keyPath,
    })
  };

  generateMenuItems = () => {

    const generateItem = item => {

      const url = item.module ? '/' + item.module + '/' : '';
      const title = item.menu.title ?? item.title;
      const key = item.key ?? item.module;
      const icon = item.menu.icon ? 'fa fa-' + item.menu.icon : '';

      return (
        <Menu.Item key={key} style={{paddingLeft:5}}>
          <Link to={url}>
            {icon && <span className={`${icon} ${styles.icon} icon-collapsed-hidden`} />}
            <span className={styles.title}>{title}</span>
          </Link>
        </Menu.Item>
      )
    };

    const generateSubmenu = items =>
      items.map(menuItem => {
        if (menuItem.children) {

          const title = menuItem.menu.title ?? menuItem.title;
          const icon = menuItem.menu.icon ? 'fa fa-' + menuItem.menu.icon : '';
          const key = menuItem.key ?? menuItem.module;

          const subMenuTitle = (
            <span key={key}>
              <span className={styles.title}>{title}</span>
              {icon && <span className={`${icon} ${styles.icon}`} />}
            </span>
          );
          return (
            <SubMenu title={subMenuTitle} key={key}>
              {generateSubmenu(menuItem.children)}
            </SubMenu>
          )
        }
        return generateItem(menuItem)
      });

    const currentRoles = this.props.user.role;

    if(menuData.length < 1) {
      return [];
    }

    const menuFilter = menuData.filter(menuItem => {
      let granted = true;
      if(menuItem.roles) {
        granted = false;
        currentRoles.forEach(userRole => {
          if(menuItem.roles.includes(userRole)) {
            granted = true;
          }
        });
      }
      return granted;
    });

    return menuFilter.map(menuItem => {

      if (menuItem.children) {

        const title = menuItem.menu.title ?? menuItem.title;
        const key = menuItem.key ?? menuItem.module;
        const icon = menuItem.menu.icon ? 'fa fa-' + menuItem.menu.icon : '';

        const subMenuTitle = (
          <span key={key}>
            <span className={styles.title}>{title}</span>
            {icon && <span className={`${icon} ${styles.icon}`} />}
          </span>
        );

        return (
          <SubMenu title={subMenuTitle} key={key}>
            {generateSubmenu(menuItem.children)}
          </SubMenu>
        )
      }
      return generateItem(menuItem)
    })
  };


  render() {
    const {selectedKeys, openedKeys} = this.state;
    const {isMobileView, isMenuCollapsed, isLightTheme} = this.props;

    const menuSettings = {
        width: 256,
        collapsible: true,
        collapsed: isMenuCollapsed,
        onCollapse: this.onCollapse,
        breakpoint: 'lg',
      };

    const menu = this.generateMenuItems();
    if(menu.length < 1) {
      return null;
    }

    return (
      <Sider
        {...menuSettings}
        className={isLightTheme ? `${styles.menu} ${styles.light}` : styles.menu}
      >
        <div className={styles.logo}>
          <div className={styles.logoContainer}>
            <img
              src={`/resources/images/logo${menuSettings.collapsed ? '-mobile' : ''}.png`}
              alt=""
            />
          </div>
        </div>
        <Scrollbars
          className={isMobileView ? styles.scrollbarMobile : styles.scrollbarDesktop}
          renderThumbVertical={({style, ...props}) => (
            <div
              {...props}
              style={{
                ...style,
                width: '4px',
                borderRadius: 'inherit',
                backgroundColor: '#c5cdd2',
                left: '1px',
              }}
            />
          )}
          autoHide
        >
          <Menu
            theme={isLightTheme ? 'light' : 'dark'}
            onClick={this.handleClick}
            selectedKeys={selectedKeys}
            openKeys={openedKeys}
            onOpenChange={this.onOpenChange}
            mode="inline"
            className={styles.navigation}
          >
            {menu}
          </Menu>
        </Scrollbars>
      </Sider>
    )
  }
}

export default compose(withRouter, connect(mapStateToProps))(MenuLeft)
